import React from 'react';
import { BLUE, RED } from '../constants/index';

const LoginHeaderText = (props) => {

  const letterSpacing={
    letterSpacing:'3px',
  }

  const blueStyle={
    color:BLUE,
    fontSize:'16px',
    fontWeight:'600'
  }

  const redStyle={
    color:RED,
    fontSize:'16px',
    fontWeight:'600'
  }

  return (
    <div className='flex-vertical item-center-align'>
    <br/><br/>
        <span style={letterSpacing} className='flex-horizontal'>
          <h5 style={redStyle}>INSTANT</h5> &nbsp;&nbsp;
          <h5 style={blueStyle}>EVERYTHING</h5>
        </span>
        <span style={letterSpacing} className='flex-horizontal'>
          <h5 style={blueStyle}>EXPERT</h5> &nbsp;&nbsp;
          <h5 style={redStyle}>ADVICE</h5>
        </span>
    </div>
  );
}

export default LoginHeaderText;


// WEBPACK FOOTER //
// ./src/components/LoginHeaderText.js